import { createAction } from 'redux-actions';

export const setCart = createAction('SET_CART');
export const clearCart = createAction('CLEAR_CART');